import React from 'react';
import { Typography, TypographyProps } from '../typography';

export interface InputLabelProps
  extends Omit<TypographyProps<'label'>, 'component'>,
    Pick<React.LabelHTMLAttributes<HTMLLabelElement>, 'htmlFor'> {
  required?: boolean;
}

export function InputLabel({ children, required, $fontWeight = 500, $fontSize = '14px', ...props }: InputLabelProps) {
  return (
    <Typography component="label" $fontSize={$fontSize} $fontWeight={$fontWeight} {...props}>
      {children}
      {required && <Typography $color="red">&nbsp;*</Typography>}
    </Typography>
  );
}
